jQuery(function($) {
  var $body = $('body'), $window = $(window);

  // setTimeout(function(){
  //   $("#Glide").glide({
  //     type: "carousel",
  //     autoplay: false,
  //     autoheight: true
  //   });
  // }, 500);


  if (location.hash.substr(0,2) === '#!') {
    console.log("test")
    var anchor = location.hash.substr(2);
    $('a[name="' + anchor + '"]').scrolly({
      topOffset : parseInt($(".page-content").css("padding-top"))
    });
  }

  $('a[href^="#"]:not(a.tab-button)').click(function(e) {
    e.preventDefault();
    var href = $(this).attr('href').substring(1);
    href = href.replace(/%20/gi," ");
    $('a[name="' + href +'"],[id="' + href + '"]').scrolly({
      topOffset : parseInt($(".page-content").css("padding-top"))
    });
  });

  $(".owl-carousel").owlCarousel({
    items:1,
    nav:true,
    navText:false,
    slideBy: "page",
    loop: true,
    autoplay: true,
    autoplayHoverPause: true,
    dots: true,
    navClass: [ 'icon-left-open-big left', 'icon-right-open-big right' ],
    dotClass: "icon-hexagon"
    // responsive: {
    //   0: {
    //     items: 2
    //   },
    //   720: {
    //     items: 3
    //   }
    // }
  });

  var $tabs = $('.tab');
  $body.on('click', 'a.tab-label[href^="#"], .tab-labels a[href^="#"]', function(event) {
    var $label = $(this), href = $label.attr('href');
    var $tab = $tabs.filter(href);
    if ($tab.length) {
      event.preventDefault();
      // We use siblings here instead of $tabs because there can be multiple tab containers in page.
      $tab.siblings('.tab').removeClass('active');
      $tab.addClass('active');
      // All tab labels, including tab anchors matching the href get `.active`
      $('.tab-labels a, a.tab-label').removeClass('active')
      .filter('[href="' + href + '"]').addClass('active');
    }
  });
});
